import * as MD from "@material-ui/core/";
import * as React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { IApplicationState } from "../../Store";
import { ILayoutState } from "../../Store/Layout/Types";
import { I18N, ILocaleInfos } from "../../Store/I18n/Types";

import _ from "lodash";

import {
  IDashboardState,
  IDateType,
  IDisplayFormat,
} from "../../Store/Dashboard/Types";
import { DrawSelect } from "./DrawSelect";
import { ISearchState } from "../../Store/Search/Types";
import { hideDrawer, showDrawer } from "../../Store/Layout/Actions";

import { isNullOrUndefined } from "../../Utils/Various";
import {
  getPoliticalGroupSpecific,
  resetFilters,
} from "../../Store/Search/Actions";
import {
  IStatsEvolutionFilters,
  IStatsState,
} from "../../Store/Statistics/Types";
import { getStatsEvolutionPerMonth } from "../../Store/Statistics/Actions";
import { IUserState } from "../../Store/User/Types";
import { Dialog } from "../Dialog";

interface IPropsFromState {
  i18n: I18N;
  layout: ILayoutState;
  localeInfos: ILocaleInfos;
  search: ISearchState;
  stats: IStatsState;
  user: IUserState;
  dashboard: IDashboardState;
}

interface InitialState {
  openError: boolean;
  errorMessage: string;
  open: boolean;
  startDate: Date;
  endDate: Date;
  done: number;
  dateCloture: Date | null;
  selectedYear: number;
  dateType: IDateType;
  // medias state
  mediasID: number[] | null;
  mediasStr: string[];
  isAllMediasSelected: boolean;
  // program types state
  programTypesID: number[] | null;
  programTypesStr: string[];
  isAllProgramTypesSelected: boolean;
  // program editors state
  politicalGroupID: number[] | null;
  politicalGroupStr: string[];
  isAllPoliticalGroupSelected: boolean;
  //datePicker
  isFullYearSelected: boolean;
  isSem1Activated: boolean;
  isSem2Activated: boolean;
  isTrim1Selected: boolean;
  isTrim2Selected: boolean;
  isTrim3Selected: boolean;
  isTrim4Selected: boolean;
  selectedMonthIndex: any;
  displayFormat: IDisplayFormat;
  periodTitle: string | undefined;
  openDialog: boolean;
  timeFilters: boolean;
}

interface IOwnState {}

interface IPropsFromDispatch {
  getPoliticalGroupSpecific: typeof getPoliticalGroupSpecific;
  getStatsEvolutionPerMonth: typeof getStatsEvolutionPerMonth;
  hideDrawer: typeof hideDrawer;
  showDrawer: typeof showDrawer;
  resetFilters: typeof resetFilters;
}

interface ISearchProps {}

type IAppState = InitialState & IOwnState;

type AllProps = MD.WithTheme &
  MD.WithStyles<typeof styles> &
  IPropsFromState &
  IPropsFromDispatch &
  ISearchProps;

const styles = (theme: any) =>
  MD.createStyles({
    form: {
      marginTop: "-5px",
      display: "flex",
      flexFlow: "row",
      flexWrap: "wrap",
    },
    formControl: {
      width: "100%",
      marginTop: "5px",
    },
    focused: {},
    searchButton: {
      paddingTop: "0px",
      paddingBottom: "0px",
      marginLeft: "10px",
      marginRight: "10px",
    },
    resetButton: {
      paddingTop: "0px",
      paddingBottom: "0px",
      marginRight: "10px",
      marginLeft: "10px",
    },
    datePicker: {
      borderBottom: "outset",
      borderBottomWidth: "1px",
    },
    monthButton: {
      padding: "5px 13.5px",
      maxWidth: "20px",
      maxHeight: "30px",
      minWidth: "20px",
      minHeight: "30px",
      borderRadius: "0px",
    },
    DateRange: {
      marginTop: "10px",
      color: "gray",
      border: "1px solid",
      backgroundColor: "#3e3c3c",
    },
    DateLabel: {
      fontSize: "13px",
      fontStyle: "italic",
      marginTop: "10px",
      paddingLeft: "10px",
      paddingBottom: "10px",
      color: "rgba(255, 255, 255, 0.7)",
    },
    dateRangePicker: {
      marginTop: "10px",
      backgroundColor: "white",
    },
    drawerPaper: {
      width: "300px",
      padding: "40px 0px 0px 0px",
      overflowX: "hidden",
      marginTop: "10px",
      backgroundColor: theme.palette.background.default,
      border: "2px solid " + theme.palette.background.paper,
    },
    drawer: {
      "&.hidden": {
        width: "0px",
      },
      flexShrink: 0,
    },
    drawerTitle: {
      color: theme.palette.primary.main,
      fontStyle: "italic",
      padding: "10px",
    },
    inputClasses: {
      width: "50%",
      border: "1px gray",
    },
  });

const initialState: InitialState = {
  openError: false,
  errorMessage: "",
  open: true,
  selectedYear: new Date().getUTCFullYear(),
  dateType: "calendar",
  dateCloture: null,
  startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  endDate: new Date(),
  done: -1,
  mediasID: null,
  mediasStr: [],
  isAllMediasSelected: true,
  programTypesID: null,
  programTypesStr: [],
  isAllProgramTypesSelected: true,
  politicalGroupID: null,
  politicalGroupStr: [],
  isAllPoliticalGroupSelected: false,
  isSem1Activated: false,
  isSem2Activated: false,
  isFullYearSelected: false,
  isTrim1Selected: false,
  isTrim2Selected: false,
  isTrim3Selected: false,
  isTrim4Selected: false,
  selectedMonthIndex: null,
  displayFormat: "duration",
  periodTitle: "",
  openDialog: false,
  timeFilters: false,
};

export class StatsEvolutionDrawerComponent extends React.Component<
  AllProps,
  IAppState
> {
  public constructor(props: AllProps) {
    super(props);
    this.state = {
      ...initialState,
    };
  }
  static getDerivedStateFromProps(props: AllProps, state: IAppState) {
    if (props.search.timeFilters !== null && state.timeFilters === true) {
      state.selectedYear = props.search.timeFilters.selectedYear;
      state.startDate = new Date(props.search.timeFilters.selectedYear, 0, 1);
      state.endDate = props.search.timeFilters.endDate;
      state.done = state.selectedYear;
      state.timeFilters = false;
    }
    if (props.dashboard.dateCloture !== null && state.done === -1) {
      let endDate = props.dashboard.dateCloture;
      state.selectedYear = endDate.getFullYear();
      state.startDate = new Date(
        endDate.getFullYear(),
        endDate.getUTCMonth(),
        1
      );
      state.endDate = endDate;
      state.dateCloture = endDate;
      state.done = state.selectedYear;
    }
    if (state.programTypesID === null) {
      if (
        props.search.searchFilters !== null &&
        props.search.searchFilters.program_types_str !== null
      ) {
        state.programTypesID = props.search.searchFilters.program_types_ids;
        state.programTypesStr = props.search.searchFilters.program_types_str;
        if (props.search.allProgramTypesID.length > 0) {
          state.isAllProgramTypesSelected =
            props.search.searchFilters.program_types_ids.length ===
            props.search.allProgramTypesID.length;
        }
      } else if (props.search.allProgramTypesID.length > 0) {
        state.programTypesID = props.search.allProgramTypesID;
        state.programTypesStr = props.search.allProgramTypesSTR;
      }
    }
    if (state.mediasID === null) {
      state.isAllMediasSelected =
        props.user.allMediasID.length === 1 ? true : false;
      if (
        props.search.searchFilters !== null &&
        props.search.searchFilters.media_str !== null
      ) {
        state.mediasID = props.search.searchFilters.media_ids;
        state.mediasStr = props.search.searchFilters.media_str;
        if (props.user.allMediasID.length > 0) {
          state.isAllMediasSelected =
            props.search.searchFilters.media_ids.length ===
            props.user.allMediasID.length;
        }
      } else if (props.user.allMediasID.length > 0 && state.mediasID === null) {
        state.mediasID =
          props.user.allMediasID.length === 1 ? props.user.allMediasID : [];
        state.mediasStr =
          props.user.allMediasSTR.length === 1 ? props.user.allMediasSTR : [];
      }
    }
    if (
      props.search.allPoliticalGroupID.length > 0 &&
      state.politicalGroupID === null
    ) {
      state.politicalGroupID = [];
      state.politicalGroupStr = [];
    }
    return state;
  }
  componentWillUnmount() {
    this.props.showDrawer();
  }
  componentDidUpdate(prevProps: AllProps, prevState: IAppState) {
    //Handle refreshing the chart when the dataset changes
    if (
      !_.isEqual(
        prevProps.search.politicalGroup,
        this.props.search.politicalGroup
      )
    ) {
      this.setState({
        politicalGroupID: [],
        politicalGroupStr: [],
      });
    }
  }
  componentDidMount() {
    if (
      this.props.search.politicalGroup.length === 0 &&
      this.props.dashboard.dateCloture !== null
    ) {
      this.props.getPoliticalGroupSpecific(
        this.props.dashboard.dateCloture.getFullYear()
      );
    }
  }
  private handleClose = () => {
    this.setState({ openError: false });
  };

  private buildSearchButton() {
    return (
      <div style={{ width: "100%", marginBottom: "20px", marginTop: "20px" }}>
        <MD.FormControl
          style={{ width: "50%" }}
          className={this.props.classes.formControl}
        >
          <MD.Button
            className={this.props.classes.resetButton}
            color="secondary"
            onClick={this.onReset.bind(this)}
            variant="contained"
          >
            {this.props.i18n._("Reset")}
          </MD.Button>
        </MD.FormControl>
        <MD.FormControl
          style={{ width: "50%" }}
          className={this.props.classes.formControl}
        >
          <MD.Button
            className={this.props.classes.searchButton}
            color="secondary"
            onClick={() => {
              this.onSearch();
            }}
            variant="contained"
          >
            {this.props.i18n._("Search")}
          </MD.Button>
        </MD.FormControl>
      </div>
    );
  }

  private onSearch() {
    const { i18n } = this.props;
    let msg: string = "",
      error: boolean = false,
      delimiter: string = "";
    if (
      this.state.politicalGroupID !== null &&
      this.state.politicalGroupID.length === 0
    ) {
      this.setState({ openDialog: true });
    }
    if (this.state.mediasID !== null && this.state.mediasID.length === 0) {
      msg = i18n._("Please select a media !");
      error = true;
      delimiter = msg + "\n";
    }
    if (
      this.state.programTypesID !== null &&
      this.state.programTypesID.length === 0
    ) {
      msg = delimiter + i18n._("Please select a program type !");
      error = true;
    }
    this.setState({ openError: error, errorMessage: msg });
    if (
      !error &&
      this.state.programTypesID !== null &&
      this.state.mediasID !== null &&
      this.state.politicalGroupID !== null
    ) {
      this.props.getStatsEvolutionPerMonth({
        year: this.state.selectedYear,
        media_ids: this.state.mediasID,
        program_type_ids: this.state.programTypesID,
        political_group_ids: this.state.politicalGroupID,
        medias_str: this.state.mediasStr,
        programs_str: this.state.programTypesStr,
      });
      this.props.hideDrawer();
    }
  }
  private onReset() {
    this.props.resetFilters();
    this.setState(initialState);
  }

  private handleYearChange(ev: any) {
    let year = ev.target.value;
    this.setState({ selectedYear: year });
    this.props.getPoliticalGroupSpecific(year);
  }
  private buildSelectYear() {
    const { classes } = this.props;
    const { selectedYear } = this.state;
    const startYear = 2018;
    let yearsRange: number[] = [];
    if (this.state.dateCloture !== null) {
      for (
        let i = startYear;
        i < this.state.dateCloture.getFullYear() + 1;
        i++
      ) {
        yearsRange.push(i);
      }
    }
    return (
      <MD.FormControl
        className={classes.formControl}
        style={{ padding: "10px", alignItems: "center" }}
      >
        <MD.Select
          labelId="tear-label"
          id="demo-simple-select-outlined"
          value={selectedYear}
          onChange={(ev) => this.handleYearChange(ev)}
          label="Age"
          variant="filled"
          input={<MD.OutlinedInput className={classes.inputClasses} />}
          renderValue={(value: any) => {
            return (
              <React.Fragment>
                <MD.Tooltip title={selectedYear}>
                  <p
                    style={{
                      margin: "0px",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                    }}
                  >
                    {selectedYear}
                  </p>
                </MD.Tooltip>
              </React.Fragment>
            );
          }}
          MenuProps={{
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: "top",
              horizontal: "left",
            },
          }}
        >
          {yearsRange.length > 0 &&
            yearsRange.map((x) => {
              return (
                <MD.MenuItem key={x} value={x}>
                  {x}
                </MD.MenuItem>
              );
            })}
        </MD.Select>
      </MD.FormControl>
    );
  }
  private closeDialog() {
    this.setState({
      openDialog: false,
    });
  }
  private saveMediasChanges(ids: number[], str: string[], bool: boolean) {
    this.setState({
      mediasID: ids,
      mediasStr: str,
      isAllMediasSelected: bool,
    });
  }
  private saveProgramTypesChanges(ids: number[], str: string[], bool: boolean) {
    this.setState({
      programTypesID: ids,
      programTypesStr: str,
      isAllProgramTypesSelected: bool,
    });
  }
  private savePoliticalGroupChanges(
    ids: number[],
    str: string[],
    bool: boolean
  ) {
    this.setState({
      politicalGroupID: ids,
      politicalGroupStr: str,
      isAllPoliticalGroupSelected: bool,
    });
  }
  public render(): React.ReactNode {
    const { classes, i18n, layout } = this.props;
    let newState = { ...this.state };
    let errorMessageCopy: string = newState.errorMessage;

    return (
      <>
        <Dialog
          title={"ALERT"}
          width={"220px"}
          closeDialog={this.closeDialog.bind(this)}
          open={this.state.openDialog}
          content={"Veuillez ajouter au moins un groupe politique !"}
        />
        <MD.Drawer
          anchor="left"
          classes={{ paper: classes.drawerPaper }}
          className={
            classes.drawer +
            (!isNullOrUndefined(layout.drawerContent) && layout.showDrawer
              ? ""
              : "hidden")
          }
          open={layout.showDrawer}
          variant="persistent"
        >
          <div>
            <span className={classes.drawerTitle}>
              Statistiques / Evolution
            </span>
            <form
              autoComplete={"off"}
              className={classes.form}
              noValidate={true}
            >
              {this.buildSelectYear()}
              {this.state.mediasID !== null && (
                <DrawSelect
                  i18n={i18n}
                  title={i18n._("Medias")}
                  list={this.props.user.medias}
                  listID={this.state.mediasID}
                  listStr={this.state.mediasStr}
                  isAllSelected={this.state.isAllMediasSelected}
                  allListIDs={this.props.user.allMediasID}
                  allListStr={this.props.user.allMediasSTR}
                  saveChanges={this.saveMediasChanges.bind(this)}
                  multiple={true}
                />
              )}
              {this.state.programTypesID !== null && (
                <DrawSelect
                  i18n={i18n}
                  title={i18n._("Program types")}
                  list={this.props.search.programTypes}
                  listID={this.state.programTypesID}
                  listStr={this.state.programTypesStr}
                  isAllSelected={this.state.isAllProgramTypesSelected}
                  allListIDs={this.props.search.allProgramTypesID}
                  allListStr={this.props.search.allProgramTypesSTR}
                  saveChanges={this.saveProgramTypesChanges.bind(this)}
                  multiple={true}
                />
              )}
              {this.props.search.isLoading && (
                <MD.Grid style={{ margin: "16px" }}>
                  <MD.CircularProgress color="primary" />
                </MD.Grid>
              )}
              {this.state.politicalGroupID !== null &&
                this.props.search.allPoliticalGroupID.length > 0 && (
                  <DrawSelect
                    i18n={i18n}
                    title={i18n._("Poltical groups")}
                    list={this.props.search.politicalGroup}
                    listID={this.state.politicalGroupID}
                    listStr={this.state.politicalGroupStr}
                    isAllSelected={this.state.isAllPoliticalGroupSelected}
                    allListIDs={this.props.search.allPoliticalGroupID}
                    allListStr={this.props.search.allPoliticalGroupSTR}
                    saveChanges={this.savePoliticalGroupChanges.bind(this)}
                    multiple={true}
                  />
                )}
              {this.buildSearchButton()}
            </form>
            <Dialog
              closeDialog={this.handleClose.bind(this)}
              open={this.state.openError}
              title={"Alert"}
              width={"350px"}
              content={
                <div>
                  {errorMessageCopy
                    .split("\n")
                    .map((paragraph: string, index: number) => {
                      return <p key={index}> {paragraph} </p>;
                    })}
                </div>
              }
              showActions
            />
          </div>
        </MD.Drawer>
      </>
    );
  }
}
const mapStateToProps = ({
  layout,
  i18n,
  ui,
  search,
  stats,
  user,
  dashboard,
}: IApplicationState) => ({
  layout,
  localeInfos: i18n.localeInfos,
  i18n: i18n.i18n,
  ui,
  search,
  stats,
  user,
  dashboard,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  hideDrawer: () => dispatch(hideDrawer()),
  showDrawer: () => dispatch(showDrawer()),
  getPoliticalGroupSpecific: (year: number) =>
    dispatch(getPoliticalGroupSpecific(year)),
  getStatsEvolutionPerMonth: (filters: IStatsEvolutionFilters) =>
    dispatch(getStatsEvolutionPerMonth(filters)),
  resetFilters: () => dispatch(resetFilters()),
});

export const StatsEvolutionDrawer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MD.withTheme(MD.withStyles(styles)(StatsEvolutionDrawerComponent)));
